import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from '../../../flux/Flux';

function withActorHeatMaps(Component) {
	class ActorHeatMapsContainer extends React.Component {

		constructor(props) {
			super(props);

			const heatMaps = Flux.Guest.isVip() ? Flux.Actor.getActorHeatMaps(props.actorId) : null;

			this.state = {
				showHeatMaps:        true,
				showDefaultHeatMaps: heatMaps === null || !heatMaps || !heatMaps.heatMaps,
				heatMaps:            heatMaps !== null ? heatMaps.heatMaps : [],
				hoursToBeOnline:     heatMaps !== null ? heatMaps.hoursToBeOnline : null,
				memo:                heatMaps !== null ? heatMaps.memo : null,
				isHeatmapActive:     true,
				actorName:           heatMaps && heatMaps.actorName ? heatMaps.actorName : '',
			};

			this.onActorHeatMapsChanged = this.onActorHeatMapsChanged.bind(this);
			this.onActorDataChanged     = this.onActorDataChanged.bind(this);
		}

		UNSAFE_componentWillMount() {
			this.onActorDataChanged();
			Flux.Actor.addActorDataChangeListener(this.onActorDataChanged);

			if (this.state.showHeatMaps && Flux.Guest.isVip() && this.state.showDefaultHeatMaps) {
				Flux.Vxql.loadHeatMaps(this.props.actorId, this.onActorHeatMapsChanged);
			}
		}

		componentWillUnmount() {
			Flux.Actor.removeActorDataChangeListener(this.onActorDataChanged);
		}

		/**
		 * @param {Number} actorId
		 */
		onActorHeatMapsChanged(actorId) {
			if (actorId !== this.props.actorId) {
				return;
			}

			const isHeatmapActive = this.state.isHeatmapActive;
			const heatMapsWrapper = Flux.Actor.getActorHeatMaps(this.props.actorId);

			const heatMaps    = heatMapsWrapper ? heatMapsWrapper.heatMaps : null;
			const errors      = heatMapsWrapper ? heatMapsWrapper.errors : null;
			const stateUpdate = {
				showHeatMaps:    isHeatmapActive && heatMaps && heatMaps.length > 0 && (!errors || errors.length === 0) ? this.state.showHeatMaps : false,
				heatMaps:        heatMaps,
				hoursToBeOnline: heatMapsWrapper ? heatMapsWrapper.hoursToBeOnline : null,
				memo:            heatMapsWrapper ? heatMapsWrapper.memo : null,
				actorName:       heatMapsWrapper.actorName,
			};

			this.setState(() => (stateUpdate));
		}

		onActorDataChanged() {
			const actorData = Flux.Actor.getActorData(this.props.actorId);
			if (!actorData) {
				return;
			}

			if (false === actorData.isHeatmapActive) {
				const stateUpdate = {
					showHeatMaps:    false,
					heatMaps:        [],
					hoursToBeOnline: null,
					memo:            null,
					isHeatmapActive: false,
					actorName:       '',
				};
				this.setState(() => (stateUpdate));
			}
		}

		render() {
			if (!this.state.showHeatMaps) {
				return null;
			}

			const spreadProps = {
				showHeatMaps:        this.state.showHeatMaps,
				showDefaultHeatMaps: this.state.showDefaultHeatMaps,
				restricted:          !Flux.Guest.isVip(),
				isLoggedIn:          Flux.Guest.isLoggedIn(),
				actorName:           this.state.actorName,
			};
			if (this.state.heatMaps !== null && this.state.heatMaps.length > 0) {
				spreadProps['daysActivity']    = this.state.heatMaps;
				spreadProps['hoursToBeOnline'] = this.state.hoursToBeOnline;
				if (this.state.memo) {
					spreadProps['memo'] = this.state.memo;
				}
			}
			return <Component {...this.props} {...spreadProps} />;
		}
	}

	ActorHeatMapsContainer.propTypes = {
		actorId: PropTypes.number.isRequired,
	};

	return ActorHeatMapsContainer;
}

export default withActorHeatMaps;
